import React from 'react';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import './styles.scss';
import { Box, useMediaQuery } from '@mui/material';
import learMoreImage from '../../../../assets/images/learnMorePhotoMovile.png';
import { LEARN_MORE_SECURE_HORIZON_URL } from '../../../../constants';
import { openUrl } from '../../../../utils';

const LearnMore = () => {
  const mobileScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  return (
    <Grid container className='learn-more'>
      <Grid item xs={12} sm={6} className='learn-more-bg' mb={{ xs: -1, md: 0 }}>
        {mobileScreen ? (
          <img
            className='learn-more-image-responsive'
            src={learMoreImage}
            alt='LearnMore'
          />
        ) : (
          <div className='learn-more-image' />
        )}
      </Grid>
      <Grid
        item
        xs={12}
        sm={6}
        className='learn-more-bg'
        pl={{ md: 9, xs: 3 }}
        pr={{ md: 2, xs: 3 }}
        pt={{ md: 6, xs: 2 }}
        pb={{ md: 6, xs: 2 }}
      >
        <p className='title-learn-more'>
          The
          {' '}
          <span className='title-learn-more-bold'>
            North American Secure Horizon
            <sup> SM </sup>
            IUL
            {' '}
          </span>
          indexed univeral life (IUL) insurance, which helps provide protection against
          major risks in retirement including potential Social Security
          reductions through an innovative
          <span className='title-learn-more-bold'>
            {' '}
            PlanGap
            <span className='registered-symbol'>® </span>
            Benefit
          </span>
          , may be a possible solution.¹
        </p>
        <Box pb={{ xs: 5 }} className='learn-more-button-container'>
          <Button
            className='learn-more-button'
            onClick={() => openUrl(LEARN_MORE_SECURE_HORIZON_URL)}
          >
            Learn more about Secure Horizon IUL
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
};

export default LearnMore;
